import {Action} from '@ngrx/store';
import {User} from '../../shared/user.model';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';
export const FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD';
export const START_PASSWORD_RESET = 'START_PASSWORD_RESET';
export const SET_REDIRECT = 'SET_REDIRECT';
export const SILENT_LOGIN_SUCCESS = 'SILENT_LOGIN_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const CLOSE_ERROR = 'CLOSE_ERROR';


export class LoginStart implements Action {
  readonly type = LOGIN_START;
  constructor(public payload: {email: string, password: string}) {}
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
}

export class SilentLoginSuccess implements Action {
  readonly type = SILENT_LOGIN_SUCCESS;
  constructor(public payload: {user: User, token: string, isAdmin: boolean, dashboards: {}[]}) {}
}

export class LoginError implements Action {
  readonly type = LOGIN_ERROR;
  constructor(public payload: {error: any}) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
  constructor(public payload: boolean = true) {}
}

export class Force_Change_Password implements Action {
  readonly type = FORCE_CHANGE_PASSWORD;
  constructor(public payload: {user: User, msg: string}) {}
}


export class SetRedirect implements Action {
  readonly type = SET_REDIRECT;
  constructor(public payload: string) {}
}

export class StartPasswordReset implements Action {
  readonly type = START_PASSWORD_RESET;
  constructor(public payload: {user: User}) {}
}

export class CloseError implements Action {
  readonly type = CLOSE_ERROR;
}

export type AuthActions =
  LoginStart |
  SetRedirect |
  LoginSuccess |
  SilentLoginSuccess |
  Force_Change_Password |
  LoginError |
  Logout |
  CloseError
  ;

